<if((input.removeWatchAjax || input.addWatchAjax) && input.hasToken)>
    <div class=`str-item-card__watch str-item-card__watch--${input.iconSize}`>
        $ {
            const watchAjax = state.isWatching ? input.removeWatchAjax : input.addWatchAjax;
        }
        <button on-click("toggleWatch")
            key="watchBtn"
            data-track=watchAjax.tracking
            aria-pressed=state.isWatching
            aria-label=watchAjax.title
            title=watchAjax.title
            class="str-item-card__watch--icon">
            <if(state.isWatching)>
                <ebay-save-filled-16-icon />
            </if>
            <else>
                <ebay-save-16-icon />
            </else>
        </button>
        <div class="str-item-card__watch--spinner" style="display: none;"></div>
    </div>
</if>
